import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EditableLabel from 'views/project-page/components/EditableLabel';
import { changeFormatOfDate } from 'utils/changeFormatOfDate';

type ReviewHeaderProps = {
  name?: string;
  description?: string;
  sizeLabel?: string | null;
  showSize?: boolean;
  item?: object | null;
  onEditDescription?: (value: string) => void;
  onSaveDescription?: (value: string) => Promise<unknown>;
  onClose?: () => void;
};

const ReviewHeader: React.FC<ReviewHeaderProps> = ({
  name,
  description,
  sizeLabel,
  showSize = false,
  item,
  onEditDescription,
  onSaveDescription,
  onClose,
}) => {
  const reviewItem = (item as Record<string, unknown> | null) ?? null;
  const hasDescription = Boolean(description?.trim());
  const createdAt =
    reviewItem && 'createdAt' in reviewItem
      ? (reviewItem.createdAt as string | number | Date | null | undefined)
      : undefined;
  const createdBy =
    reviewItem && 'createdBy' in reviewItem ? (reviewItem.createdBy as string | null | undefined) : undefined;

  return (
    <div className="review-header-bar">
      <div className="review-header">
        <div className="review-line review-line--title">
          <span className="review-title review-header-title">{name}</span>
          <span className="review-description-separator">-</span>
          <span
            className={`review-value review-value--inline ${
              hasDescription ? 'review-value--filled' : 'review-value--placeholder'
            }`}
          >
            <EditableLabel
              label={description ?? ''}
              item={(reviewItem as Record<string, any>) ?? {}}
              onEdit={onEditDescription ?? (() => {})}
              onSave={onSaveDescription}
              keyToEdit="description"
              placeholder={'Double click to write a description'}
            />
          </span>
        </div>
        {(createdAt || createdBy || showSize) && (
          <div className="review-line review-line--compact">
            {createdAt && (
              <>
                <span className="review-subtitle">Created at : </span>
                <span className="review-value" style={{ flex: '0 1 auto' }}>
                  {changeFormatOfDate(createdAt)}
                </span>
              </>
            )}
            {createdBy && (
              <>
                <span className="review-subtitle" style={{ marginLeft: createdAt ? 24 : 0 }}>
                  Created by :
                </span>
                <span className="review-value" style={{ flex: '0 1 auto' }}>
                  {createdBy}
                </span>
              </>
            )}
            {showSize && (
              <>
                <span className="review-subtitle" style={{ marginLeft: createdAt || createdBy ? 24 : 0 }}>
                  Size:
                </span>
                <span className="review-value review-value--filled" style={{ flex: '0 1 auto' }}>
                  {sizeLabel ?? '-'}
                </span>
              </>
            )}
          </div>
        )}
      </div>

      <IconButton size="large" className={`exit-icon`} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </div>
  );
};

export default ReviewHeader;
